import React from "react";
import { styled } from "styled-components";

const ThumbsDownSvg = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2220_18162)">
        <path
          d="M5.89286 15C5.32143 15 4.78571 14.7615 4.37857 14.3231C3.97143 13.8846 3.75 13.3077 3.75 12.6923C3.75 11.7538 3.94286 10.8154 4.32143 9.96923C4.33571 9.93846 4.33571 9.9 4.32143 9.86154C4.24286 9.86154 4.17143 9.83846 4.1 9.80769H2.05C1.01429 9.80769 0.157143 9.01538 0.05 7.96923C0.0142857 7.62308 0 7.26923 0 6.92308C0 4.69231 0.714286 2.50769 2.00714 0.776923C2.37857 0.284615 2.94286 0 3.57143 0H6.44286C6.82143 0 7.24286 0.0692308 7.62857 0.207692L9.85 1.00769C10.1214 1.10769 10.4071 1.15385 10.7 1.15385H11.1857C11.2214 1.08462 11.2571 1.01538 11.3071 0.953846C11.4857 0.715385 11.7571 0.576923 12.0429 0.576923H12.6929C13.5929 0.576923 14.3643 1.16154 14.6143 2.03846C14.8786 2.96154 15.0071 3.92308 15.0071 4.90769C15.0071 6.14615 14.7929 7.35385 14.3786 8.5C14.0857 9.29231 13.35 9.80769 12.5071 9.80769H11.7571C11.4143 9.80769 11.1 9.60769 10.9286 9.27692C10.85 9.13077 10.8071 8.96923 10.8 8.80769C10.6214 8.91538 10.4571 9.06923 10.3143 9.26154C9.71429 10.0923 8.96429 10.7615 8.1 11.2615C7.77857 11.4462 7.35714 11.7769 7.16429 12.2846C7.03571 12.6308 6.97143 12.9923 6.97143 13.3538V13.8385C6.97143 14.1462 6.85714 14.4385 6.65714 14.6538C6.45714 14.8692 6.18571 14.9923 5.9 14.9923L5.89286 15ZM5.39286 9.80769C5.40714 10.0308 5.37143 10.2615 5.28571 10.4615C4.97857 11.1538 4.82143 11.9231 4.82143 12.6846C4.82143 12.9923 4.93571 13.2846 5.13571 13.5C5.33571 13.7154 5.60714 13.8385 5.89286 13.8385V13.3538C5.89286 12.8385 5.98571 12.3385 6.16429 11.8538C6.40714 11.1923 6.90714 10.6308 7.59286 10.2385C8.32143 9.81538 8.95714 9.24615 9.46429 8.54615C9.93571 7.9 10.5929 7.51538 11.2786 7.49231C11.6143 6.68462 11.7929 5.79231 11.7929 4.89231C11.7929 3.99231 11.6214 3.11538 11.2786 2.29231H10.7071C10.3071 2.29231 9.90714 2.22308 9.52143 2.08462L7.29286 1.28462C7.02143 1.18462 6.73571 1.13846 6.45 1.13846H3.57857C3.27857 1.13846 3.01429 1.26154 2.85 1.48462C1.69286 3.03846 1.07857 4.90769 1.07857 6.90769C1.07857 7.21538 1.09286 7.53077 1.12143 7.83846C1.16429 8.29231 1.57143 8.63846 2.05714 8.63846H5.86429C6.15714 8.63846 6.4 8.9 6.4 9.21538C6.4 9.53077 6.15714 9.79231 5.86429 9.79231H5.4L5.39286 9.80769ZM11.9286 8.65385H12.5071C12.9071 8.65385 13.25 8.42308 13.3786 8.07692C13.75 7.06923 13.9357 6 13.9357 4.90769C13.9357 4.04615 13.8214 3.19231 13.5857 2.37692C13.4786 1.99231 13.1143 1.73077 12.6929 1.73077H12.2143C12.65 2.72308 12.8643 3.79231 12.8643 4.9C12.8643 6.09231 12.6 7.27692 12.0929 8.32308C12.0929 8.32308 12.0929 8.33846 12.0857 8.34615C12.0357 8.44615 11.9857 8.54615 11.9357 8.64615L11.9286 8.65385Z"
          fill="#010101"
        />
      </g>
      <defs>
        <clipPath id="clip0_2220_18162">
          <rect width="15" height="15" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const ThumbsUpSvg = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2220_18161)">
        <path
          d="M11.4286 15H8.55714C8.15714 15 7.75714 14.9308 7.37143 14.7923L5.14286 13.9923C4.87143 13.8923 4.58571 13.8462 4.3 13.8462H3.91429C3.93571 14.0769 3.88571 14.3077 3.76429 14.5154C3.58571 14.8231 3.28571 15 2.95714 15H2.30714C1.40714 15 0.635714 14.4154 0.385714 13.5385C0.135714 12.6077 0 11.6462 0 10.6692C0 9.43077 0.214286 8.22308 0.628571 7.07692C0.921429 6.28462 1.65714 5.76923 2.5 5.76923H3.25C3.58571 5.76923 3.88571 5.95385 4.05714 6.26154C4.29286 6.16154 4.50714 5.98462 4.69286 5.73077C5.3 4.9 6.04286 4.23077 6.90714 3.73077C7.22857 3.54615 7.65 3.22308 7.84286 2.70769C7.97143 2.36154 8.03571 2.00769 8.03571 1.63846V1.15385C8.03571 0.846154 8.15 0.553846 8.35 0.338462C8.55 0.123077 8.82857 0 9.10714 0C9.67857 0 10.2214 0.238462 10.6214 0.676923C11.0286 1.11538 11.25 1.69231 11.25 2.30769C11.25 3.26154 11.0571 4.17692 10.6786 5.03077C10.6643 5.06154 10.6643 5.1 10.6786 5.13846C10.7571 5.13846 10.8286 5.16154 10.9 5.19231H12.95C13.9857 5.19231 14.8429 5.98462 14.95 7.03077C14.9857 7.37692 15 7.73077 15 8.07692C15 10.3077 14.2857 12.4923 12.9857 14.2231C12.6143 14.7154 12.05 15 11.4214 15H11.4286ZM4.30714 12.6923C4.70714 12.6923 5.10714 12.7615 5.48571 12.9L7.71429 13.7C7.98571 13.8 8.27143 13.8462 8.56429 13.8462H11.4357C11.7357 13.8462 12 13.7231 12.1643 13.5C13.3071 11.9692 13.9429 10.0462 13.9357 8.07692C13.9357 7.76923 13.9214 7.45385 13.8929 7.14615C13.85 6.69231 13.4429 6.34615 12.9571 6.34615H9.11429C8.82143 6.34615 8.57857 6.08462 8.57857 5.76923C8.57857 5.45385 8.82143 5.19231 9.11429 5.19231H9.61429C9.6 4.96923 9.63571 4.73846 9.72143 4.53846C10.0286 3.83846 10.1857 3.09231 10.1857 2.30769C10.1857 2 10.0714 1.70769 9.87143 1.49231C9.67143 1.27692 9.4 1.15385 9.11429 1.15385V1.63846C9.11429 2.15385 9.02143 2.66154 8.84286 3.13846C8.6 3.8 8.1 4.36154 7.41429 4.75385C6.68571 5.17692 6.05 5.74615 5.54286 6.44615C5.13571 7 4.6 7.36154 4.02857 7.46154C3.5 8.43077 3.22143 9.53846 3.22143 10.6692C3.22143 11.3615 3.32143 12.0385 3.52857 12.6923H4.31429H4.30714ZM2.5 6.92308C2.1 6.92308 1.75714 7.15385 1.62857 7.5C1.25714 8.50769 1.07143 9.57692 1.07143 10.6692C1.07143 11.5231 1.18571 12.3769 1.42143 13.2C1.52857 13.5846 1.89286 13.8462 2.31429 13.8462H2.79286C2.74286 13.7308 2.69286 13.6154 2.65 13.5C2.65 13.4923 2.65 13.4846 2.64286 13.4769C2.31429 12.5846 2.14286 11.6462 2.14286 10.6769C2.14286 9.36154 2.46429 8.06923 3.07143 6.92308H2.49286H2.5Z"
          fill="#010101"
        />
      </g>
      <defs>
        <clipPath id="clip0_2220_18161">
          <rect width="15" height="15" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const ThumbsDownSolidSvg = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.83125 3.4375H10.4781C10.9831 4.20241 11.2515 5.09909 11.25 6.01563C11.2515 6.93216 10.9831 7.82885 10.4781 8.59375H10.3856C9.88188 8.59375 9.42688 8.8725 9.11625 9.26875C8.6311 9.88775 8.02207 10.3987 7.32812 10.7688C6.87625 11.0087 6.48437 11.3663 6.295 11.8406C6.16201 12.173 6.0937 12.5277 6.09375 12.8856V13.2812C6.09375 13.4056 6.04436 13.5248 5.95646 13.6127C5.86855 13.7006 5.74932 13.75 5.625 13.75C5.25204 13.75 4.89435 13.6018 4.63063 13.3381C4.36691 13.0744 4.21875 12.7167 4.21875 12.3438C4.21875 11.6238 4.38125 10.9419 4.67062 10.3325C4.83687 9.98375 4.60375 9.53125 4.2175 9.53125H2.26375C1.6225 9.53125 1.04813 9.0975 0.98 8.45938C0.951642 8.19261 0.937455 7.92452 0.9375 7.65625C0.9375 5.87625 1.5575 4.24125 2.59313 2.95563C2.83563 2.65438 3.21 2.5 3.59625 2.5H6.10625C6.40851 2.49982 6.70882 2.54836 6.99563 2.64375L8.94188 3.29375C9.22868 3.38915 9.52899 3.43769 9.83125 3.4375ZM13.5431 8.76438C13.8781 7.91313 14.0625 6.98625 14.0625 6.01563C14.0625 5.25313 13.9487 4.51688 13.7375 3.82375C13.575 3.2925 13.06 2.96875 12.5044 2.96875H11.9375C11.6594 2.96875 11.4875 3.28 11.6106 3.53C11.98 4.28 12.1881 5.12375 12.1881 6.01563C12.1898 7.044 11.9083 8.05297 11.3744 8.93188C11.2212 9.18375 11.3919 9.53125 11.6869 9.53125H12.345C12.865 9.53125 13.3519 9.24813 13.5431 8.76438Z"
        fill="black"
      />
    </svg>
  );
};

const ThumbsUpSolidSvg = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.68313 11.5625C4.41751 11.5625 4.17063 11.415 4.07376 11.1675C3.85922 10.6214 3.74939 10.0398 3.75001 9.45312C3.75001 8.35938 4.12438 7.35437 4.75126 6.55688C4.84563 6.43688 4.98438 6.36375 5.12626 6.30875C5.42188 6.19438 5.68251 5.9875 5.88376 5.73125C6.36893 5.11227 6.97796 4.60138 7.67188 4.23125C8.12376 3.99125 8.51563 3.63375 8.70501 3.15937C8.83801 2.82703 8.90632 2.47234 8.90626 2.11437V1.71875C8.90626 1.59443 8.95564 1.4752 9.04355 1.38729C9.13146 1.29939 9.25069 1.25 9.37501 1.25C9.74797 1.25 10.1057 1.39816 10.3694 1.66188C10.6331 1.9256 10.7813 2.28329 10.7813 2.65625C10.7813 3.37625 10.6188 4.05813 10.3294 4.6675C10.1631 5.01625 10.3963 5.46875 10.7825 5.46875H12.7363C13.3775 5.46875 13.9519 5.9025 14.02 6.54063C14.0481 6.80438 14.0625 7.07188 14.0625 7.34375C14.0651 9.05397 13.4807 10.7133 12.4069 12.0444C12.1644 12.3456 11.79 12.5 11.4038 12.5H8.89376C8.59188 12.5 8.29126 12.4513 8.00438 12.3563L6.05813 11.7062C5.77132 11.6109 5.47101 11.5623 5.16876 11.5625H4.68313ZM1.45688 6.70438C1.11246 7.57982 0.936251 8.51237 0.937507 9.45312C0.936717 10.1958 1.04625 10.9345 1.26251 11.645C1.42501 12.1763 1.94063 12.5 2.49626 12.5H3.06251C3.34063 12.5 3.51251 12.1887 3.38938 11.9387C3.00822 11.1657 2.81059 10.3151 2.81188 9.45312C2.81188 8.38562 3.10938 7.3875 3.62563 6.53687C3.77876 6.285 3.60813 5.9375 3.31313 5.9375H2.65626C2.13626 5.9375 1.64813 6.22062 1.45688 6.70438Z"
        fill="black"
      />
    </svg>
  );
};

export const MessageFeedback = ({
  feedback,
  sendFeedback,
}: {
  feedback?: boolean;
  sendFeedback: (feedback: boolean) => Promise<void>;
}) => {
  return (
    <>
      <ToggleIconButton state={feedback ? "on" : "off"} onClick={feedback ? undefined :() => sendFeedback(true)}>
        <ThumbsUpSvg />
      </ToggleIconButton>

      <ToggleIconButton state={feedback === false ? "on" : "off"} onClick={feedback === false ? undefined : () => sendFeedback(false)}>
        <ThumbsDownSvg />
      </ToggleIconButton>
    </>
  );
};

const ToggleIconButton = styled.button<{ state?: "on" | "off" }>`
	--black-a1: rgba(0, 0, 0, 0.05);
	--black-a2: rgba(0, 0, 0, 0.1);
	--black-a3: rgba(0, 0, 0, 0.15);
	--black-a7: rgba(0, 0, 0, 0.5);

  all: unset;

  font-family: inherit;
  border-radius: 8px;
  height: 28px;
  width: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--black-a7);
  background-color: white;

  &:hover {
    background-color: var(--black-a1);
  }

  &:active {
    background-color: var(--black-a3);
  }

  ${({ state }) => state === "on" && `
    background-color: var(--black-a2);

    &:hover {
      background-color: var(--black-a2);
    }
  `}
`;

